export type ActivationType =
  | 'authenticatorInstall'
  | 'tokenConfimation'
  | 'qrcode'
  | 'tokenAuthneticator'
  | 'confirmation'
  | 'authenticationProblem'
  | 'authenticationProblemRecovery'
  | 'tokenDisable';

export interface StatusMfa {
  isEnabledForTenant: boolean;
  isEnabledForAccount: boolean;
  isActiveForAccount: boolean;
  canBeDisabled: boolean;
  canBeEnabled: boolean;
  canBeReset: boolean;
}
export interface StateMfa {
  mfa: StatusMfa;
}

export interface FormTokenItem {
  mfacode: string;
}

export enum MfaRequirementEnum {
  disabledForEveryone = 0,
  enabledForEveryone = 1,
  requiredForAdministratorsEnabledForOthers = 2,
  requiredForEveryone = 3,
  enabledForAdminstratorsDisabledForOthers = 4,
  requiredForAdminstratorsDisabledForOthers = 5,
}

export interface passwordConfigAPI {
  mfaEnable: boolean;
  mfaRequirement: MfaRequirementEnum;
  minimumPasswordLength: number;
  failedLoginAttemptsBeforeLockAccount: number;
  passwordExpirationInDays: number;

  webSessionLifetimeInSeconds: number;
  applicationSessionLifetimeInSeconds: number;

  requiresDigit: boolean;
  requiresLowerCaseCharacter: boolean;
  requiresSpecialCharacter: boolean;
  requiresUpperCaseCharacter: boolean;
}

export interface passwordConfigState {
  mfaEnable: boolean;
  mfaRequirement: number;
  minimumPasswordLength: number;
  failedLoginAttemptsBeforeLockAccount: number;
  passwordExpirationInDays: number;

  webSessionLifetimeInSeconds: number;
  applicationSessionLifetimeInSeconds: number;

  requiresDigit: boolean;
  requiresLowerCaseCharacter: boolean;
  requiresSpecialCharacter: boolean;
  requiresUpperCaseCharacter: boolean;
}
